<template lang="pug">
y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="350px")
  v-card
    v-card-title.h6.basic800--text.px-4 Brand new dashboard
    v-card-text.p2.primary500--text.px-4
      div.mb-2 We are excited to tell you, we have brand new dashboard for you!
      div.mb-2 Updates for the old dashboard will be 
        |
        strong until 30/11/2023 only
        |
        span . Some function might not be there if you 
        strong do not migrate 
        |
        span to the new dashboard.
      div Would you like to go there?
    v-card-actions
      v-spacer
      v-btn(color="danger500", text @click="showModal = false")
        .button-Aa-small.primary400--text Later
      v-btn.mr-2(color="info500" depressed @click="onOpenNewDashboard")
        .button-AA-small.basic100--text Yes, take me there!
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onOpenNewDashboard () {
      if (process.env.VUE_APP_ENV === 'prod') {
        window.open('https://dashboard.yezza.com', '_self')
        return
      }
      window.open('https://dashboard-test.yezza.com', '_self')
    }
  },
}
</script>

<style scoped></style>
